import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { useFacet } from '~/composables/_next/useFacet';
import { parseCategory } from '~/components/Layout/Search/helpers/parseResult';
import VirtualSearchBox from '~/components/_next/renderless/VirtualSearchBlock.vue';
import SearchListOrganism from '~/components/_next/organisms/SearchListOrganism.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import useRightPath from '~/composables/useRightPath';
import SearchAutocompleteOrganism from '~/components/_next/organisms/SearchAutocompleteOrganism.vue';
import { AisInstantSearch, AisHits, AisIndex, AisConfigure, AisStats, AisStateResults } from 'vue-instantsearch';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
import { watchDebounced } from '@vueuse/core';
import { PageTypes } from '~/types/PageTypes';
import AzButtonText from '~/components/_next/atoms/AzButtonText.vue';
import useShippingCountry from '~/composables/useShippingCountry';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchOverlayAlgoliaOrganism',
  props: {
    isOverlayOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open', 'close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useNuxt2App = useNuxt2App(),
      localePath = _useNuxt2App.localePath,
      $trackers = _useNuxt2App.$trackers;
    var _useRightPath = useRightPath(),
      pathGetter = _useRightPath.getPagePath;
    var _useAlgoliaSearch = useAlgoliaSearch(),
      client = _useAlgoliaSearch.searchClient,
      indexProduct = _useAlgoliaSearch.indexProduct,
      indexRecipe = _useAlgoliaSearch.indexRecipe,
      indexAdvice = _useAlgoliaSearch.indexAdvice;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useFacet = useFacet('search'),
      categoriesResult = _useFacet.result,
      categoriesSearch = _useFacet.search;
    var aisStateResultsProductRef = ref(null);
    var aisStateResultsAdviceRef = ref(null);
    var aisStateResultsRecipeRef = ref(null);
    var productHits = ref(0);
    var recipeHits = ref(0);
    var adviceHits = ref(0);
    var activateDesktopAutocomplete = computed(function () {
      return isMobile.value ? !props.isOverlayOpen : true;
    });
    var searchBar = ref(null);
    var searchBarMobile = ref(null);
    var typing = ref('');
    var searchClient = ref(null);
    var getPagePath = ref(function () {
      return '';
    });
    onMounted(function () {
      if (process.client) {
        searchClient.value = client;
        getPagePath.value = pathGetter;
      }
    });
    var hasTypedEnough = computed(function () {
      var _typing$value;
      return (typing === null || typing === void 0 ? void 0 : (_typing$value = typing.value) === null || _typing$value === void 0 ? void 0 : _typing$value.length) >= 3;
    });
    var _useLazyAsyncData = useLazyAsyncData('search-overlay', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _typing$value2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!hasTypedEnough.value) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return Promise.all([categoriesSearch({
                filters: {},
                page: 1,
                perPage: 20,
                sort: 'latest',
                phrase: (_typing$value2 = typing.value) !== null && _typing$value2 !== void 0 ? _typing$value2 : ''
              })]);
            case 3:
              return _context.abrupt("return", {
                categories: parseCategory(categoriesResult.value)
              });
            case 6:
              return _context.abrupt("return", {
                categories: []
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), {
        server: false,
        immediate: false
      }),
      results = _useLazyAsyncData.data,
      search = _useLazyAsyncData.execute;
    watchDebounced(typing, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return search();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), {
      debounce: 500,
      maxWait: 1000
    });

    /**
     * Opens the overlay if it's currently closed.
     */
    function open() {
      if (!props.isOverlayOpen) {
        emit('open');
      }
    }

    /**
     * Updates the typing value with the provided input.
     * @param {string} value - The input value to set as the current typing query.
     */
    function typingQuery(value) {
      typing.value = value;
    }

    /**
     * Closes the overlay if it's currently open.
     */
    function close() {
      if (props.isOverlayOpen) {
        emit('close');
      }
    }
    function closeAndSendToAnalytics(type) {
      $trackers.gtm.pushEvent('overlay_search', {
        event: 'generic_event',
        event_action: 'send',
        event_category: 'engagement',
        event_label: type,
        event_name: 'search_overlay',
        search_term: typing.value,
        search_result_name: "button-redirection-".concat(type),
        index: "button-redirection-".concat(type)
      });
      close();
    }

    /**
     * Get preview details for a list of products based on their masterVariantID.
     * @param { 'product' | 'recipe' | 'advice' } type - The type of item (product, recipe, advice).
     * @param { AisHit[] } items - The array of product objects.
     * @returns { { link: string; name: string; image: string }[] } - Array of preview objects.
     */
    function getProductPreviewBySku(type, items) {
      var previews = items === null || items === void 0 ? void 0 : items.map(function (item) {
        if (!item) {
          console.warn('Product is undefined or null');
          return {
            link: '',
            name: '',
            image: '',
            category: ''
          };
        }
        var currentLocale = locale !== null && locale !== void 0 ? locale : '';
        var link = '';
        var image = '';
        var name = '';
        if (type === 'product') {
          var _product$masterVarian, _product$variants, _product$variants$fin, _product$variants$fin2, _getPagePath$value, _getPagePath$value2;
          var product = item;
          var masterSku = (_product$masterVarian = product === null || product === void 0 ? void 0 : product.masterVariantID) !== null && _product$masterVarian !== void 0 ? _product$masterVarian : '';
          image = product === null || product === void 0 ? void 0 : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : (_product$variants$fin = _product$variants.find(function (v) {
            return (v === null || v === void 0 ? void 0 : v.sku) === masterSku;
          })) === null || _product$variants$fin === void 0 ? void 0 : (_product$variants$fin2 = _product$variants$fin.images) === null || _product$variants$fin2 === void 0 ? void 0 : _product$variants$fin2[0];
          link = (_getPagePath$value = getPagePath === null || getPagePath === void 0 ? void 0 : (_getPagePath$value2 = getPagePath.value) === null || _getPagePath$value2 === void 0 ? void 0 : _getPagePath$value2.call(getPagePath, PageTypes.PDP, currentLocale, {
            slug: product === null || product === void 0 ? void 0 : product.slug
          })) !== null && _getPagePath$value !== void 0 ? _getPagePath$value : '';
          name = product.name;
        } else if (type === 'advice') {
          var _getPagePath$value3, _getPagePath$value4;
          var advice = item;
          link = (_getPagePath$value3 = getPagePath === null || getPagePath === void 0 ? void 0 : (_getPagePath$value4 = getPagePath.value) === null || _getPagePath$value4 === void 0 ? void 0 : _getPagePath$value4.call(getPagePath, PageTypes.ADP, currentLocale, {
            slug: advice === null || advice === void 0 ? void 0 : advice.url
          })) !== null && _getPagePath$value3 !== void 0 ? _getPagePath$value3 : '';
          name = advice.title;
        } else if (type === 'recipe') {
          var _getPagePath$value5, _getPagePath$value6;
          var recipe = item;
          link = (_getPagePath$value5 = getPagePath === null || getPagePath === void 0 ? void 0 : (_getPagePath$value6 = getPagePath.value) === null || _getPagePath$value6 === void 0 ? void 0 : _getPagePath$value6.call(getPagePath, PageTypes.RDP, currentLocale, {
            slug: recipe === null || recipe === void 0 ? void 0 : recipe.url
          })) !== null && _getPagePath$value5 !== void 0 ? _getPagePath$value5 : '';
          name = recipe.title;
        }
        return {
          link: link,
          name: name,
          image: image,
          category: ''
        };
      });
      return previews !== null && previews !== void 0 ? previews : [];
    }
    watch(function () {
      return searchBar.value;
    }, function (el) {
      if (el !== null && el !== void 0 && el.$el) {
        var desktopSearchBar = el.$el.querySelector('input');
        desktopSearchBar === null || desktopSearchBar === void 0 ? void 0 : desktopSearchBar.addEventListener('click', focusMobileSearchbar);
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(function () {
      var _searchBar$value, _searchBar$value$$el;
      var desktopSearchBar = (_searchBar$value = searchBar.value) === null || _searchBar$value === void 0 ? void 0 : (_searchBar$value$$el = _searchBar$value.$el) === null || _searchBar$value$$el === void 0 ? void 0 : _searchBar$value$$el.querySelector('input');
      if (desktopSearchBar) {
        desktopSearchBar.removeEventListener('click', focusMobileSearchbar);
      }
    });
    watch(function () {
      return props.isOverlayOpen;
    }, function (newVal, oldVal) {
      if (newVal && !oldVal) {
        nextTick(function () {
          focusMobileSearchbar();
        });
      }
    });
    function focusMobileSearchbar() {
      var _searchBar$value2, _searchBar$value2$$el, _searchBarMobile$valu, _searchBarMobile$valu2;
      if (!isMobile.value) return;
      var desktopInput = (_searchBar$value2 = searchBar.value) === null || _searchBar$value2 === void 0 ? void 0 : (_searchBar$value2$$el = _searchBar$value2.$el) === null || _searchBar$value2$$el === void 0 ? void 0 : _searchBar$value2$$el.querySelector('input');
      var mobileInput = (_searchBarMobile$valu = searchBarMobile.value) === null || _searchBarMobile$valu === void 0 ? void 0 : (_searchBarMobile$valu2 = _searchBarMobile$valu.$el) === null || _searchBarMobile$valu2 === void 0 ? void 0 : _searchBarMobile$valu2.querySelector('input');
      if (!mobileInput) {
        return;
      }
      desktopInput === null || desktopInput === void 0 ? void 0 : desktopInput.blur();
      nextTick(function () {
        setTimeout(function () {
          mobileInput.focus();
        }, 50);
      });
    }
    watch(function () {
      var _aisStateResultsProdu, _aisStateResultsProdu2, _aisStateResultsProdu3, _aisStateResultsProdu4;
      return (_aisStateResultsProdu = aisStateResultsProductRef.value) === null || _aisStateResultsProdu === void 0 ? void 0 : (_aisStateResultsProdu2 = _aisStateResultsProdu.$data) === null || _aisStateResultsProdu2 === void 0 ? void 0 : (_aisStateResultsProdu3 = _aisStateResultsProdu2.state) === null || _aisStateResultsProdu3 === void 0 ? void 0 : (_aisStateResultsProdu4 = _aisStateResultsProdu3.results) === null || _aisStateResultsProdu4 === void 0 ? void 0 : _aisStateResultsProdu4.nbHits;
    }, function (newValue) {
      productHits.value = newValue !== null && newValue !== void 0 ? newValue : 0;
    });
    watch(function () {
      var _aisStateResultsAdvic, _aisStateResultsAdvic2, _aisStateResultsAdvic3, _aisStateResultsAdvic4;
      return (_aisStateResultsAdvic = aisStateResultsAdviceRef.value) === null || _aisStateResultsAdvic === void 0 ? void 0 : (_aisStateResultsAdvic2 = _aisStateResultsAdvic.$data) === null || _aisStateResultsAdvic2 === void 0 ? void 0 : (_aisStateResultsAdvic3 = _aisStateResultsAdvic2.state) === null || _aisStateResultsAdvic3 === void 0 ? void 0 : (_aisStateResultsAdvic4 = _aisStateResultsAdvic3.results) === null || _aisStateResultsAdvic4 === void 0 ? void 0 : _aisStateResultsAdvic4.nbHits;
    }, function (newValue) {
      adviceHits.value = newValue !== null && newValue !== void 0 ? newValue : 0;
    });
    watch(function () {
      var _aisStateResultsRecip, _aisStateResultsRecip2, _aisStateResultsRecip3, _aisStateResultsRecip4;
      return (_aisStateResultsRecip = aisStateResultsRecipeRef.value) === null || _aisStateResultsRecip === void 0 ? void 0 : (_aisStateResultsRecip2 = _aisStateResultsRecip.$data) === null || _aisStateResultsRecip2 === void 0 ? void 0 : (_aisStateResultsRecip3 = _aisStateResultsRecip2.state) === null || _aisStateResultsRecip3 === void 0 ? void 0 : (_aisStateResultsRecip4 = _aisStateResultsRecip3.results) === null || _aisStateResultsRecip4 === void 0 ? void 0 : _aisStateResultsRecip4.nbHits;
    }, function (newValue) {
      recipeHits.value = newValue !== null && newValue !== void 0 ? newValue : 0;
    });
    var router = useRouter();
    var redirectTriggered = ref(false);
    watch(function () {
      var _aisStateResultsProdu5, _aisStateResultsProdu6, _aisStateResultsProdu7, _aisStateResultsProdu8, _aisStateResultsProdu9, _aisStateResultsProdu0;
      return (_aisStateResultsProdu5 = aisStateResultsProductRef.value) === null || _aisStateResultsProdu5 === void 0 ? void 0 : (_aisStateResultsProdu6 = _aisStateResultsProdu5.$data) === null || _aisStateResultsProdu6 === void 0 ? void 0 : (_aisStateResultsProdu7 = _aisStateResultsProdu6.state) === null || _aisStateResultsProdu7 === void 0 ? void 0 : (_aisStateResultsProdu8 = _aisStateResultsProdu7.results) === null || _aisStateResultsProdu8 === void 0 ? void 0 : (_aisStateResultsProdu9 = _aisStateResultsProdu8._rawResults) === null || _aisStateResultsProdu9 === void 0 ? void 0 : (_aisStateResultsProdu0 = _aisStateResultsProdu9[0]) === null || _aisStateResultsProdu0 === void 0 ? void 0 : _aisStateResultsProdu0.renderingContent;
    }, function (renderingContent) {
      var _renderingContent$red;
      if (!redirectTriggered.value && renderingContent !== null && renderingContent !== void 0 && (_renderingContent$red = renderingContent.redirect) !== null && _renderingContent$red !== void 0 && _renderingContent$red.url) {
        redirectTriggered.value = true;
        router.push({
          path: renderingContent.redirect.url
        });
        close();
        setTimeout(function () {
          redirectTriggered.value = false;
        }, 500);
      }
    });
    return {
      __sfc: true,
      emit: emit,
      props: props,
      currentCountry: currentCountry,
      locale: locale,
      localePath: localePath,
      $trackers: $trackers,
      pathGetter: pathGetter,
      client: client,
      indexProduct: indexProduct,
      indexRecipe: indexRecipe,
      indexAdvice: indexAdvice,
      isMobile: isMobile,
      categoriesResult: categoriesResult,
      categoriesSearch: categoriesSearch,
      aisStateResultsProductRef: aisStateResultsProductRef,
      aisStateResultsAdviceRef: aisStateResultsAdviceRef,
      aisStateResultsRecipeRef: aisStateResultsRecipeRef,
      productHits: productHits,
      recipeHits: recipeHits,
      adviceHits: adviceHits,
      activateDesktopAutocomplete: activateDesktopAutocomplete,
      searchBar: searchBar,
      searchBarMobile: searchBarMobile,
      typing: typing,
      searchClient: searchClient,
      getPagePath: getPagePath,
      hasTypedEnough: hasTypedEnough,
      results: results,
      search: search,
      open: open,
      typingQuery: typingQuery,
      close: close,
      closeAndSendToAnalytics: closeAndSendToAnalytics,
      getProductPreviewBySku: getProductPreviewBySku,
      focusMobileSearchbar: focusMobileSearchbar,
      router: router,
      redirectTriggered: redirectTriggered,
      VirtualSearchBox: VirtualSearchBox,
      SearchListOrganism: SearchListOrganism,
      AzButton: AzButton,
      AzIcon: AzIcon,
      SearchAutocompleteOrganism: SearchAutocompleteOrganism,
      AisInstantSearch: AisInstantSearch,
      AisHits: AisHits,
      AisIndex: AisIndex,
      AisConfigure: AisConfigure,
      AisStats: AisStats,
      AisStateResults: AisStateResults,
      AzButtonText: AzButtonText
    };
  }
});